import { jsx as _jsx } from "react/jsx-runtime";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import { forwardRef } from "react";
import clsx from "clsx";
import { InternalDragHandle, } from "@amzn/awsui-components-react/polaris/internal/do-not-use/drag-handle";
import { CLICK_DRAG_THRESHOLD } from "../item-container";
import styles from "./styles.css.js";
import testUtilsStyles from "./test-classes/styles.css.js";
function DragHandle({ ariaLabelledBy, ariaDescribedBy, onPointerDown, onKeyDown, activeState, initialShowButtons, onDirectionClick, dragHandleTooltipText, }, ref) {
    return (_jsx(InternalDragHandle, { ref: ref, className: clsx(styles.handle, activeState === "pointer" && styles.active, activeState === "uap" && testUtilsStyles["active-uap"]), ariaLabelledBy: ariaLabelledBy, ariaDescribedby: ariaDescribedBy, variant: "drag-indicator", tooltipText: dragHandleTooltipText, onKeyDown: onKeyDown, onPointerDown: onPointerDown, directions: {
            "block-start": "active",
            "block-end": "active",
            "inline-start": "active",
            "inline-end": "active",
        }, triggerMode: "keyboard-activate", onDirectionClick: onDirectionClick, initialShowButtons: initialShowButtons, hideButtonsOnDrag: true, clickDragThreshold: CLICK_DRAG_THRESHOLD }));
}
export default forwardRef(DragHandle);
//# sourceMappingURL=index.js.map